const queryStringToJson = (queryString) => {
  if (!queryString) return {};
  return queryString
    .substring(1) // '?' 제거
    .split('&') // 각 key=value 쌍으로 분리
    .reduce((acc, pair) => {
      const [key, value] = pair.split('=');
      acc[decodeURIComponent(key)] = decodeURIComponent(value || '');
      return acc;
    }, {});
};

export default queryStringToJson;